import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { SettingsPersonalSecurityContextImport } from "../../../../../provider/settings/security/personal_security/SettingsPersonalSecurityContextProvider";

const SettingsPersonalSecurityButtons = (props: {
  type?: number | undefined;
  name: string;
}) => {

  const { processing, submitPassword } =
    SettingsPersonalSecurityContextImport();

  return (
    <ButtonSingle
      handleClick={() => submitPassword()}
      width={300}
      processing={processing}
    >
      {AppTranslation.text("submit")}
    </ButtonSingle>
  );
};

export default SettingsPersonalSecurityButtons;
